module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "d7e294"
    }
  }, [_c('h1', {
    staticClass: "chapno"
  }, [_vm._v("1")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "c1"
    }
  }, [_c('h2', {
    staticClass: "chapttl",
    attrs: {
      "id": "d7e295"
    }
  }, [_vm._v("The Reverse Mortgage Story")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e297"
    }
  }, [_vm._v("Stories are meant to be entertaining, but they are also instructive. From humble beginnings to scandal and a happy ending, this story provides a framework for understanding today's reverse mortgages.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e299"
    }
  }, [_c('b', [_vm._v("What Is a Reverse Mortgage?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e302"
    }
  }, [_vm._v("Before we begin the story, you should understand a little bit about reverse mortgages or the story will not have any meaning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e304"
    }
  }, [_c('i', [_vm._v("A reverse mortgage is the true home equity loan.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e307"
    }
  }, [_vm._v("— Ken Scholen, founder of the National Center for Home Equity Conversion and director of the AARP Foundation Reverse Mortgage Education Project")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e309"
    }
  }, [_vm._v("To understand the simple truth of Mr. Scholen's statement, think back to when you bought your home. If you purchased your home with the assistance of a loan, a lender evaluated your income and loaned you funds based on your ability to repay the loan. This loan is known as a standard or forward mortgage. In exchange for the loan, you granted the lender a security interest in your home to protect the lender in the event you did not repay the loan. Over time, you paid down and maybe even paid off the loan. As you paid down your loan balance, you built up equity in your home. Equity is the difference between the market value of your home and the amount you still owe on your loan. When you pay off your home loan, your equity equals 100 percent of the value of your home; you are said to own your home “free and clear” and you are entitled to the entire sales price minus closing costs when the home is sold.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e311"
    }
  }, [_vm._v("A reverse mortgage allows homeowners age 62 and over to convert some of their home equity into cash without selling or moving out. Homeowners with a reverse mortgage remain living in their homes, retain ownership of their home, and receive tax-free cash disbursements. A reverse mortgage does not need to be repaid until the borrower dies, sells the home, or moves permanently out of the home. Over time, the reverse mortgage loan balance grows and your equity declines. That is why reverse mortgages are also known as home equity conversion loans; your built-up equity is converted into usable cash without having to sell your home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e313"
    }
  }, [_c('b', [_vm._v("Comparison of Forward and Reverse Mortgages")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "d7e318"
    }
  }, [_c('img', {
    attrs: {
      "alt": "illustration",
      "src": "images/p3-001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e319"
    }
  }, [_vm._v("As the illustration shows, over time with forward mortgages, debt falls and equity rises as the loan is repaid each month. The opposite is true of reverse mortgages; over time debt rises and equity falls as loan advances are made and interest accumulates. For homes that continue to appreciate, the equity falls more slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e322"
    }
  }, [_vm._v("Now that we know what a reverse mortgage is, let's begin the story by introducing the characters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e324"
    }
  }, [_c('b', [_vm._v("The Beginning of the Story")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e327"
    }
  }, [_c('i', [_vm._v("The man with a new idea is a crank until the idea succeeds.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e330"
    }
  }, [_vm._v("— Mark Twain")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e332"
    }
  }, [_vm._v("Nelson Haynes of Deering Savings and Loan may not have been thought of as a crank, but his idea certainly was new. Mr. Haynes is credited with making the first reverse mortgage loan, to the widow of his high school football coach in 1961. One can imagine the confused looks he received when explaining the idea to his lender peers. You want us to lend her money and we won't get paid back until she dies! Now he is viewed as a good person whose desire to help one widow cover her living expenses has helped many senior homeowners do so as well.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e334"
    }
  }, [_vm._v("Another good person to know in the field of reverse mortgages is Ken Scholen. He has studied reverse mortgages and has advocated for government involvement and consumer protections since the 1970s. In 1981 he founded the National Center for Home Equity Conversion, a nonprofit dedicated to reverse mortgages. One of Mr. Scholen's most helpful contributions to consumers is his method of analyzing and comparing costs of reverse mortgages. This method is discussed later in the book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e336"
    }
  }, [_vm._v("Of course, a history lesson would not be complete without some bad characters. And, sure enough, early on in reverse mortgage history there were many instances of unscrupulous individuals taking advantage of seniors who did not clearly understand all of the terms of the loans. One early loan provision that received a lot of criticism was appreciation sharing. Appreciation sharing entitled the lender to a percentage of the increase in value of the home (known as appreciation) over the term of the loan. These provisions resulted in huge profits to lenders, especially for homes in communities with steadily rising home values, and dramatically reduced the amount of equity remaining for the borrower and the borrower's heirs when the home was sold. In some of the worst cases, the lender could take the title and force the borrower out of the home if the debt became greater than the value of the home. Other onerous provisions required borrowers to purchase annuities or other financial products in order to obtain the loan. All of these mechanisms reduced the amount of funds available to seniors in need and risked the security of their home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e338"
    }
  }, [_c('b', [_vm._v("A Better Reverse Mortgage")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e341"
    }
  }, [_vm._v("Things started to improve in the 1980s, when Congress created a government-backed insurance program for reverse mortgages. The Housing and Community Development Act of 1987 established a federal mortgage insurance program to be provided by the Federal Housing Administration (FHA), a division of the U.S. Department of Housing and Urban Development (HUD). HUD's job is to implement and enforce federal housing and community development laws. Under the 1987 Act, HUD was authorized through FHA to insure 2,500 home equity conversion mortgages (HECMs). That volume cap has been increased several times, and the current limit is 250,000 mortgages. A bill has been introduced to Congress that would remove the limitation on the number of reverse mortgages FHA can insure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e343"
    }
  }, [_vm._v("Today, HECMs represent more than 90 percent of all reverse mortgages. Because the federal government insures this product, it is considered the safest reverse mortgage. All FHA-approved lenders are eligible to participate in the HECM program.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e345"
    }
  }, [_vm._v("Things further improved for reverse mortgages once the financial industry began regulating itself. The National Reverse Mortgage Lenders Association (NRMLA), founded in 1997, developed best business practices and a code of conduct for its members. One best practice is to clearly distinguish between reverse mortgage products and the sale of insurance or annuities and to not coerce borrowers into buying additional products in conjunction with a reverse mortgage. Lenders are also directed to not recommend a product simply because that product generates higher fees; lenders are to make recommendations based on the product that makes the best financial sense for the customer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e348"
    }
  }, [_c('b', [_vm._v("Great Expectations")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e351"
    }
  }, [_vm._v("With advanced consumer protection and industry self-regulation, potential reverse mortgage borrowers now have access to vastly better information and products than they did twenty and even ten years ago. In fact, today you can hardly find an article on retirement planning that does not at least mention reverse mortgages. Financial planners now need to know about reverse mortgages in order to completely advise their clients about retirement planning options.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e353"
    }
  }, [_vm._v("The government is as enthusiastic about reverse mortgages as are retirement planners. In its Strategic Plan for Fiscal Years 2006–2011, HUD identifies HECMs as a means to achieve its goal of helping low-income seniors secure living arrangements that are safe, affordable, and support independence. Because state governments are responsible for a large portion of Medicaid costs, they see reverse mortgages as a promising way to control costs by enabling seniors to cover more of their own costs, including covering the cost of preventive care that can delay or eliminate the need for assisted living.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e355"
    }
  }, [_vm._v("In addition to low-income seniors using home equity for health care and other necessary expenses, wealthy baby-boomers are likely to use their home equity as a retirement asset. They may use the loan proceeds for long-awaited luxury items or trips or simply to maintain their pre-retirement standard of living. Because the funds can be used for any purpose, the possible uses for reverse mortgage funds are as diverse as the population itself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e357"
    }
  }, [_vm._v("Most analysts and commentators agree that although reverse mortgage activity is at an all-time high, the percentage of reverse mortgages is small compared to the size of the potential market. The proportion of the United States population that is 65 years of age and older is growing rapidly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e359"
    }
  }, [_c('b', [_vm._v("Share of U.S. Population 65 and Older")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "d7e364"
    }
  }, [_c('img', {
    attrs: {
      "alt": "illustration",
      "src": "images/p7-001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e365"
    }
  }, [_vm._v("Data courtesy of U.S. Census Bureau; “65+ in the United States: 2005;” published December 2005")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e367"
    }
  }, [_vm._v("Almost 80 percent of these older Americans own their own homes, and many of those homes are owned free and clear of any mortgages. That amounts to nearly $2.5 trillion of home equity, based on a year 2000 estimate. According to projections from Wells Fargo, the reverse mortgage market could be as large as $74 billion by 2015. Many industry experts believe that the number of reverse mortgages will explode as consumers become more educated about the safeguards of today's reverse mortgages; specifically, that the most common reverse mortgages are non-recourse, which means the borrower will never owe more than the value of the house. The non-recourse nature of reverse mortgages is explained further in Chapter 2.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e369"
    }
  }, [_vm._v("There are forces at work other than an aging population and improving consumer education that point toward a dramatic increase in reverse mortgages. Life expectancy is now about 80 years for men and 85 years for women. As life expectancies rise, so does the need for long-term health care. The future funding need for older Americans is enormous, and Medicare and Medicaid cover only part of the cost. Most people would rather stay in their own home than move to a nursing home, but many find that the cost of staying at home is high, above and beyond out-of-pocket health-care costs. Even with a low mortgage payment, or none at all, fluctuating energy prices and unexpected repairs can stress most seniors' budgets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e371"
    }
  }, [_vm._v("While Americans are living longer and healthier lives, the reality is that the odds of having a disability or chronic illness increase with age. In a 2000 study, the U.S. Census Bureau found that 42 percent of people age 65 and older have a chronic condition causing disability, and 83 percent of those age 85 and older have multiple chronic conditions that result in functional limitations. According to a publication by the National Institute for Health Care Management, the number of people with multiple chronic illnesses is expected to increase by over 30 percent between 2000 and 2020. Chapter 6 explores in more detail the relationship between reverse mortgages and costs for long-term care.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e374"
    }
  }, [_vm._v("To make matters even tighter, most researchers agree that somewhere between one-quarter to one-half of households are not adequately saving for retirement. Only about one-half of workers contribute to employer-sponsored pension plans, and IRA participation is even lower. According to a report by The Retirement Security Project, a nonprofit organization dedicated to improving the retirement income prospects of American workers, one-half of American workers near retirement have $15,000 or less saved.\nAbout one-quarter of workers who are offered 401(k) plans do not participate in the plans, and those who do participate rarely make the maximum contribution.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e376"
    }
  }, [_vm._v("Low rates of saving, along with a rapidly aging population, longer life spans, and a rise in the need for long-term care, make the reverse mortgage an increasingly important retirement planning tool. Given the size of the potential market for reverse mortgages and the enthusiasm in the industry for making the products better, it is not surprising that the number of reverse mortgages is finally starting to move. Reverse mortgage volume was up 73 per cent between 2005 and 2006. This is good news for consumers because the growth gives lenders more experience and competition for business.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e378"
    }
  }, [_vm._v("More good news came in October 2006, when Ginnie Mae (a government-owned mortgage association within HUD that sells mortgages in the secondary market, which results in lower costs for borrowers) announced it had created a mortgage-backed security for home equity conversion mortgages. This allows issuers to securitize and sell HECMs and should increase competition among lenders. In turn, potential borrowers should see more product choices and lower costs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e380"
    }
  }, [_vm._v("Despite the fact that reverse mortgages make economic sense, especially in light of future need, there can be psychological drawbacks for certain would-be borrowers. The reaction people have to the idea of a reverse mortgage depends partly on their age and the generation in which they grew up. Many potential borrowers have spent a lifetime paying off their home mortgage, and asking them to reverse that process is counterintuitive. It can also wound the pride associated with building equity and passing on the value of a home, or the home itself, to one's children.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e382"
    }
  }, [_vm._v("Considering a reverse mortgage can bring up all sorts of emotions and questions. The only way to overcome these feelings and make good objective decisions is through proactive education and communication. One thing is clear for today's seniors: planning for retirement depends increasingly on individual action. Since knowledge should precede action, let us now clear up some common misconceptions about reverse mortgages.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e384"
    }
  }, [_c('b', [_vm._v("Misconceptions")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e387"
    }
  }, [_vm._v("Despite all the changes in the reverse mortgage industry, misconceptions still abound. These misconceptions explain the dismissive response a lot of people give when you mention reverse mortgages. Here is a list of five common misconceptions, each followed by the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e389"
    }
  }, [_c('b', [_vm._v("1. The lender gets the house.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e392"
    }
  }, [_vm._v("This is a widely held misconception. All the reverse mortgage products we discuss in this book are simply loans, which means that the borrower continues to own the home; the lender only has a lien against the home. A lien is a security interest against a property that secures the lender's right to repayment of the loan. The lender cannot foreclose as long as the borrower abides by the terms of the loan agreement, which typically means maintaining the home and paying the real estate taxes and insurance. Some of the confusion people have may arise from the fact that most borrowers sell their home if they move out so they can pay off the reverse mortgage loan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e394"
    }
  }, [_c('b', [_vm._v("2. People only get reverse mortgages as a last resort.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e397"
    }
  }, [_vm._v("In the early days of reverse mortgages this may have been the case, but today many borrowers are more likely to get a reverse mortgage because it fits with their retirement circumstances and goals. In fact, more and more people are taking out reverse mortgages to have a financial safety net for future expenses. Remember, though, that the high cost of a reverse mortgage means that careful planning should precede any decision to obtain a reverse mortgage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e400"
    }
  }, [_c('b', [_vm._v("3. There will be no estate, and my heirs might even owe money.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e403"
    }
  }, [_vm._v("First of all, a borrower's heirs should not owe money. The reverse mortgages we discuss in this book are non-recourse, which means the lender cannot collect more than the value of the house. Second, whether a borrower will have any estate to pass on to his or her heirs may be more complicated than just taking a look at the value of the home. In most cases, the allowable loan amount will be less than the value of the house. If the house continues to appreciate, and the house ultimately is sold, it is likely that the sales price will be more than the loan balance, resulting in some amount of cash that would pass to the borrower's heirs. Who gets what, of course, depends on your estate plan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e405"
    }
  }, [_c('b', [_vm._v("4. I can't qualify.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e408"
    }
  }, [_vm._v("Unlike a conventional loan, the borrower's income and credit are not factors for qualifying for a reverse mortgage. The borrower's lender will run a credit report, but only to be sure the borrower does not owe the government any money (such as unpaid taxes). And although any existing mortgages or liens on the home must be paid off, the proceeds from the reverse mortgage can be used to pay off pre-existing debt. This reduces the amount of money available to you, but you still qualify for the loan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e410"
    }
  }, [_c('b', [_vm._v("5. The costs are too high.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e413"
    }
  }, [_vm._v("Reverse mortgages are expensive, but cost is relative to the value you receive. If the borrower only keeps the reverse mortgage for a short time or uses the proceeds for an expense that could have been taken care of with another readily accessible resource, then the value may not justify the costs. On the other hand, if the borrower intends to keep the reverse mortgage for a longer period and use the proceeds for an expense that would be difficult to manage otherwise, the cost of a reverse mortgage may be well worth the value. Later in this book, we discuss value and ways to manage the high fees and costs associated with reverse mortgages.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e415"
    }
  }, [_c('b', [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e418"
    }
  }, [_vm._v("Now you know the reverse mortgage story. There have been many improvements in the reverse mortgage industry, and you can expect to see many more. Starting with a clean slate, freed of misconceptions, it is time to get the facts about reverse mortgages. Read on to learn the basic anatomy of a reverse mortgage.")])])]), _c('a', {
    attrs: {
      "id": "c1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae36fbda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Krae_9781440501029_epub_c1.vue
// module id = 84
// module chunks = 0